/**
 * Instrumentation #3 (CU-86d345rgy): tell the API that the lead-distribution opt-in toggle
 * was actually shown to the customer, so "saw the toggle but didn't opt in" is queryable per
 * region. Best-effort telemetry backed by an idempotent server-side upsert — it never throws,
 * so a failed/slow beacon can't block the booking form.
 */
export interface OfferShownHttp {
    post(url: string): Promise<unknown>;
}

export async function recordOfferShown(http: OfferShownHttp, orderId: number | string | null): Promise<boolean> {
    if (!orderId) {
        return false;
    }

    try {
        await http.post(`/customers/book/orders/${orderId}/lead-distribution/offer-shown`);

        return true;
    } catch {
        // Telemetry only — swallow failures (a later render may retry).
        return false;
    }
}
